import { useParams } from 'react-router';

import { useGetContactQuery } from 'store/api/version-api.slice';

import LinkedMembersManagement from '../components/LinkedMemberManagement';
import { getMemberStatus, getMemberType, getPrimaryMemberName, getStats } from '../utils';

const LinkedMemberManagementContainer = () => {
	const { primary_member, portal_id } = useParams();

	const { data = {}, isLoading } = useGetContactQuery({
		primaryMember: primary_member,
		portalId: portal_id
	});

	const primaryMember = getPrimaryMemberName(data);
	const memberStatus = getMemberStatus(data);
	const memberType = getMemberType(data);
	const stats = getStats(data);

	return (
		<LinkedMembersManagement
			loading={isLoading}
			member={primaryMember}
			status={memberStatus}
			memberType={memberType}
			stats={stats}
		/>
	);
};

export default LinkedMemberManagementContainer;
